import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useSocket } from './SocketContext';
import { buildApiUrl } from '../config/api.config';

const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [newMessageNotification, setNewMessageNotification] = useState(null);
    const socket = useSocket();

    const fetchMessages = async () => {
        try {
            const token = localStorage.getItem('token');
            const userDetails = JSON.parse(localStorage.getItem("userDetails"));
            const selectedRestId = localStorage.getItem("currentRestaurantId");
            let activeRestaurantId = (userDetails?.role === 'owner' || userDetails?.role === 'user') ? selectedRestId : userDetails?.restaurantId;

            // Don't make API call if no token
            if (!token) {
                setMessages([]);
                setLoading(false);
                return;
            }

            // Handle populated restaurantId object
            if (activeRestaurantId && typeof activeRestaurantId === 'object') {
                activeRestaurantId = activeRestaurantId._id;
            }

            if (!activeRestaurantId) {
                setMessages([]);
                setLoading(false);
                return;
            }

            const response = await axios.get(buildApiUrl(`message/admin/all-reviews?restaurantId=${activeRestaurantId}`), {
                headers: { 'auth-token': token }
            });
            setMessages(response.data);
            setLoading(false);
        } catch (error) {
            // Handle 401 errors - token might be expired
            if (error.response?.status === 401) {
                console.log('Token expired or invalid. Please login again.');
                // Optional: Redirect to login or trigger re-authentication
            }
            console.error('Error fetching messages:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMessages();

        if (socket) {
            socket.emit('joinAdminMessageRoom');
            
            socket.on('newMessage', (message) => {
                setMessages(prev => [message, ...prev]);
                setNewMessageNotification({
                    id: message._id,
                    name: `${message.firstName} ${message.lastName}`,
                    content: message.message
                });
                setTimeout(() => setNewMessageNotification(null), 5000);
            });

            socket.on('messageUpdated', (updatedMessage) => {
                setMessages(prev => prev.map(msg => 
                    msg._id === updatedMessage._id ? updatedMessage : msg
                ));
            });

            return () => {
                socket.off('newMessage');
                socket.off('messageUpdated');
            };
        }
    }, [socket]);

    return (
        <MessageContext.Provider value={{ messages, loading, fetchMessages, newMessageNotification }}>
            {children}
        </MessageContext.Provider>
    );
};

export const useMessages = () => {
    return useContext(MessageContext);
};